import {message, Modal} from 'antd'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import {familyBook_deleteFamilyBook_Api} from 'apis/familyBook'

// Confirm + gọi API xóa sổ (soft delete) - dùng chung cho list (FamilyBooks.js) và trang chi tiết
// (FamilyBookDetail.js, xóa xong cần điều hướng về list nên nhận thêm onDeleted riêng ở đó).
const useDeleteFamilyBookAction = (t, onDeleted) => {
    const {handleAsyncAction: doDelete} = useAsyncAction({
        apiInfo: familyBook_deleteFamilyBook_Api,
        onSuccess: () => {
            message.success(t('family book deleted'))
            onDeleted && onDeleted()
        },
        onError: () => message.error(t('error occurred')),
    })

    const confirmDelete = (item) => {
        Modal.confirm({
            rootClassName: 'family-theme',
            title: t('confirm delete family book'),
            // BE xoá kèm toàn bộ thành viên + bí tích/ơn gọi/liên kết của sổ (xem
            // FamilyBook::purgeWithMembers) - cảnh báo rõ trước khi xoá, không chỉ hiện mỗi tên sổ.
            content: t('confirm delete family book description', {name: item.title}),
            okText: t('delete'),
            okButtonProps: {danger: true},
            cancelText: t('cancel'),
            onOk: () => doDelete({}, {id: item.id}),
        })
    }

    return confirmDelete
}

export default useDeleteFamilyBookAction
